import { createReducer, on } from '@ngrx/store';

import { QuickDepositActions } from './quick-deposit-actions';
import { defaultQuickDepositState } from './quick-deposit.state';

export const quickDepositStateReducer = createReducer(
    defaultQuickDepositState,
    on(QuickDepositActions.depositAvailable, (state, action) => {
        return {
            ...state,
            isAvailable: action.payload.available,
        };
    }),
    on(QuickDepositActions.fundsAdded, (state, action) => {
        return {
            ...state,
            isAvailable: false,
            fundsAdded: {
                success: action.payload.success,
                depositAmount: action.payload.amount,
            },
        };
    }),
    on(QuickDepositActions.quickDepositOpen, (state, action) => {
        return {
            ...state,
            isAvailable: false,
            isOpen: true,
        };
    }),
    on(QuickDepositActions.quickDepositVisible, (state, action) => {
        return {
            ...state,
            isVisible: action.visible,
        };
    }),
    on(QuickDepositActions.depositProcessing, (state, action) => {
        return {
            ...state,
            isProcessing: action.processing,
        };
    }),
    on(QuickDepositActions.quickDepositClose, (state, action) => {
        return {
            ...defaultQuickDepositState,
            isVisible: action.close,
            isOpen: false,
        };
    }),
    on(QuickDepositActions.cashierPage, (state, action) => {
        return {
            ...state,
            page: action.payload.name,
        };
    }),
    on(QuickDepositActions.selectedPaymentMethod, (state, action) => {
        return {
            ...state,
            selectedpaymentMethod: action.payload.paymentMethodName,
        };
    }),
    on(QuickDepositActions.windowResize, (state, action) => {
        return {
            ...state,
            height: action.payload.height,
        };
    }),
    on(QuickDepositActions.windowScroll, (state, action) => {
        return {
            ...state,
            deltaY: action.payload.deltaY,
        };
    }),
);
